import * as React from 'react'

import { TextLanguage } from '../common/Text'
import Button, { ButtonProps } from './Button'

type Props = {
  localizeKey: string
} & ButtonProps

const ButtonLanguage: React.FC<Props> = ({ localizeKey, disabled, ...others }) => {
  return (
    <>
      <Button
        variant="unstyled"
        disabled={disabled}
        rounded="none"
        borderRadius="0"
        minW="0"
        minH="0"
        h="auto"
        textDecoration="none"
        _hover={disabled ? {} : { color: 'hover', textDecoration: 'none' }}
        _disabled={{ cursor: 'not-allowed', textDecoration: 'underline' }}
        {...others}
      >
        <TextLanguage as="span" localizeKey={localizeKey} lineHeight={1} />
      </Button>
    </>
  )
}

export default ButtonLanguage
